import * as R from 'ramda';


export const createActionCreator = (type) => (payload) => ({
    type,
    payload
});


export const isType = R.curry((type, action) => R.ifElse(
    R.complement(R.is(Object)),
    R.F,
    R.propEq('type', type)
)(action));


// WEBPACK FOOTER //
// ./src/utils/ActionUtils.js